export const isEven = (num: number) => !Boolean(num % 2);
